  <table class="orgApp-custom-table" mat-table [dataSource]="dataSource">
  <!-- Define columns -->
  <ng-container *ngFor="let column of columns" [matColumnDef]="column">
    <th mat-header-cell *matHeaderCellDef class="column-header-color">{{ column !=='action'? (this.parentTranslator + '.' + column | translate ):'' }}</th>
    <td mat-cell *matCellDef="let element">  <span *ngIf="column=='day'" class="elem-column">{{ element[column] }}</span> <span *ngIf="column !='day'" >{{ element[column] }}</span></td>
  </ng-container>

  <!-- Additional column for actions -->
  <ng-container matColumnDef="actions">
    <th class="column-header-color" mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <span #changeDet="matMenuTrigger" class="material-icons orgApp-more-option color-dot-but float-right" [matMenuTriggerFor]="menu">more_vert</span>
      <mat-menu class="orgApp-action-menu" #menu="matMenu">
          <button *ngIf="actions[0].edit" (click)="manageSelectedRow(element,'edit')" class="cdm-btn-holiday " mat-menu-item >
            <svg class="edit-icon" >
              <use xlink:href="/assets/icons/edit.svg#no-element" />
            </svg>
            <span class="orgApp-action-icon-btn">{{ 'Edit' }}</span>
          </button>
        <div>
          <button *ngIf="actions[0].ignore"  (click)="manageSelectedRow(element,'ignore')"  class="cdm-btn-holiday" mat-menu-item>
          <svg  class="ignore-icon"><use xlink:href="/assets/icons/ignore.svg#no-element" /></svg>
            <span class="orgApp-action-icon-btn">{{ 'Ignore'}}</span>
          </button>
        </div>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns.concat('actions')" class="orgApp-header-row"></tr>
  <tr mat-row *matRowDef="let row; columns: columns.concat('actions');"></tr>
</table>